import { ACTION_TYPES } from '../utils/Constants';
import moment from 'moment';
import _ from 'lodash';
let initialState = {
    videoCallDetails: {},
    isEndCallLoading: false,
    isChatLoading: false,
    isRecordLoading: false,
    isRecording: false,
    userIds: [],
    isSendMessageLoading: false,
    isMute: true,
    chatList: [],
    chatCount: 0,
    receiverImage: '',
    senderImage: '',
    unreadCount: 0,
    subjective: '',
    objective: '',
    assessment: '',
    plan: '',
    visitEncounter: {},
    patientHandout: '',
    from: 'Work',
    reason: 'Injury',
    fromDate: moment().format('MMM DD,YYYY'),
    dueDate: moment().format('MMM DD,YYYY'),
    studentDetails: {},
    participantsDetails: {},
    isRecordingCall: false,
    showAnonymousEndCallPopup: false,
};

/**
 * video call screen reducer
 * @param {*} state
 * @param {*} action
 */
const VideoCallReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case ACTION_TYPES.PHYSICIAN.VIDEO_CALL_CONNECTED_SUCESS:
            return {
                ...state,
                videoCallDetails: {
                    ...action.payload,
                    // Preserve API credentials if they exist (separate from socket credentials)
                    vonage_api_credentials: state.videoCallDetails?.vonage_api_credentials || action.payload?.vonage_api_credentials,
                    // Preserve socket credentials if they exist
                    vonage_session_details: state.videoCallDetails?.vonage_session_details || action.payload?.vonage_session_details,
                },
                isRecording: action.payload?.recording,
            };
        case ACTION_TYPES.IM_PHYSICIAN.GET_VISIT_INFORMATION:
            return {
                ...state,
                studentDetails: action.payload,
            };
        case ACTION_TYPES.IM_PHYSICIAN.GET_VONAGE_SESSION_DETAILS:
            return {
                ...state,
                videoCallDetails: {
                    ...state.videoCallDetails,
                    // Store API credentials separately from socket credentials
                    vonage_api_credentials: {
                        apiKey: action.payload.apikey,
                        sessionId: action.payload.opentokSession,
                        token: action.payload.opentokToken,
                        moderatorToken: action.payload.moderatorToken,
                    },
                },
            };
        case ACTION_TYPES.PHYSICIAN.VIDEO_CALL_END_CLICKED:
            return {
                ...state,
                isEndCallLoading: true,
            };
        case ACTION_TYPES.PHYSICIAN.VIDEO_CALL_END_SUCESSS:
            return {
                ...state,
                videoCallDetails: action.payload,
                isEndCallLoading: false,
                chatCount: 0,
                chatList: [],
            };
        case ACTION_TYPES.PHYSICIAN.VIDEO_CALL_END_ERROR:
            return {
                ...state,
                isEndCallLoading: false,
            };
        case ACTION_TYPES.PHYSICIAN.VIDEO_CALL_GET_CHAT_CLICKED:
            return {
                ...state,
                isChatLoading: false,
            };
        case ACTION_TYPES.PHYSICIAN.VIDEO_CALL_GET_CHAT_SUCESSS:
            return {
                ...state,
                isChatLoading: false,
                chatList: [...action.payload.data?.messages, ...state.chatList],
                receiverImage: action.payload.receiverImage,
                senderImage: action.payload.senderImage,
            };

        case ACTION_TYPES.PHYSICIAN.VIDEO_CALL_SENDER_RECEVIER_IMAGE:
            return {
                ...state,
                isChatLoading: false,
                receiverImage: action.payload.receiverImage,
                senderImage: action.payload.senderImage,
            };
        case ACTION_TYPES.PHYSICIAN.VIDEO_CALL_GET_CHAT_ERROR:
            return {
                ...state,
                isChatLoading: false,
            };

        case ACTION_TYPES.PHYSICIAN.ON_MESSAGE_RECEVICE:
            return {
                ...state,
                chatList: _.cloneDeep([...state.chatList, action.payload]),
            };
        case ACTION_TYPES.PHYSICIAN.ON_MESSAGE_SEND_CLICKED:
            return {
                ...state,
                isSendMessageLoading: true,
            };
        case ACTION_TYPES.PHYSICIAN.ON_MESSAGE_SEND_SUCESSS:
            return {
                ...state,
                isSendMessageLoading: false,
                chatList: _.cloneDeep([...state.chatList, action.payload]),
            };

        case ACTION_TYPES.PHYSICIAN.ON_MESSAGE_SEND_ERROR:
            return {
                ...state,
                isSendMessageLoading: false,
            };

        case ACTION_TYPES.PHYSICIAN.UNREAD_COUNT_ADD:
            return {
                ...state,
                chatCount: state.chatCount + action.payload,
            };

        case ACTION_TYPES.PHYSICIAN.UNREAD_COUNT_CLEAR:
            return {
                ...state,
                chatCount: 0,
            };

        case ACTION_TYPES.PHYSICIAN.VIDEO_CALL_START_RECORD_CLICKED:
            return {
                ...state,
                isRecordLoading: true,
            };

        case ACTION_TYPES.PHYSICIAN.VIDEO_CALL_START_RECORD_SUCESSS:
            return {
                ...state,
                isRecordLoading: false,
                isRecording: true,
            };

        case ACTION_TYPES.PHYSICIAN.VIDEO_CALL_START_RECORD_ERROR:
            return {
                ...state,
                isRecordLoading: false,
            };

        case ACTION_TYPES.PHYSICIAN.VIDEO_CALL_STOP_RECORD_CLICKED:
            return {
                ...state,
                isRecordLoading: true,
            };

        case ACTION_TYPES.PHYSICIAN.VIDEO_CALL_STOP_RECORD_SUCESSS:
            return {
                ...state,
                isRecordLoading: false,
                isRecording: false,
            };

        case ACTION_TYPES.PHYSICIAN.VIDEO_CALL_STOP_RECORD_ERROR:
            return {
                ...state,
                isRecordLoading: false,
            };

        case ACTION_TYPES.PHYSICIAN.SOAP_NOTE_UPDATE:
            return {
                ...state,
                subjective: action.payload.subjective,
                objective: action.payload.objective,
                assessment: action.payload.assessment,
                plan: action.payload.plan,
            };

        case ACTION_TYPES.PHYSICIAN.GET_ENCOUNTER_SUCESSS:
            return {
                ...state,
                visitEncounter: action.payload,
            };
        case ACTION_TYPES.PHYSICIAN.PATIENT_HANDOUT_UPDATE:
            return {
                ...state,
                patientHandout: action.payload,
            };

        case ACTION_TYPES.PATIENT.PHYSICIAN_CAMERA_ON:
            return {
                ...state,
                isMute: true,
            };
        case ACTION_TYPES.PATIENT.PHYSICIAN_CAMERA_OFF:
            return {
                ...state,
                isMute: false,
            };
        case ACTION_TYPES.PHYSICIAN.LIVE_STREAM_PARTICIPANTS:
            return {
                ...state,
                participantsDetails: action.payload,
            };
        case ACTION_TYPES.PHYSICIAN.RECORDING_CALL:
            return {
                ...state,
                isRecordingCall: action.payload.isRecording,
            };
        case ACTION_TYPES.PHYSICIAN.userIds:
            return {
                ...state,
                userIds: action.payload,
            };
        case ACTION_TYPES.ANONYMOUS_SIDE_DOCTOR_END_CALL:
            return {
                ...state,
                showAnonymousEndCallPopup: action.payload,
            };
        default:
            break;
    }
    return state;
};
export default VideoCallReducer;
